export let InteractionEvent = /*#__PURE__*/function (InteractionEvent) {
  InteractionEvent["Hover"] = "hover";
  InteractionEvent["Click"] = "click";
  InteractionEvent["Select"] = "select";
  InteractionEvent["Active"] = "active";
  InteractionEvent["Drag"] = "drag";
  return InteractionEvent;
}({});